import React from 'react';
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';

const PermissionEditor = ({ permissions, onChange }) => {
  const permissionLabels = {
    canViewClients: 'Ver clientes',
    canCreateClients: 'Crear clientes',
    canEditClients: 'Editar clientes',
    canDeleteClients: 'Eliminar clientes',
    canProcessPayments: 'Procesar pagos',
    canViewReports: 'Ver reportes',
    canExportData: 'Exportar datos',
    canManageUsers: 'Gestionar usuarios',
    canViewAuditLogs: 'Ver logs de actividad',
    canConfigureSystem: 'Configurar sistema'
  };

  const permissionGroups = {
    'Clientes': ['canViewClients', 'canCreateClients', 'canEditClients', 'canDeleteClients'],
    'Pagos': ['canProcessPayments'],
    'Reportes': ['canViewReports', 'canExportData'],
    'Administración': ['canManageUsers', 'canViewAuditLogs', 'canConfigureSystem']
  };

  const handleToggle = (permission) => {
    onChange({
      ...permissions,
      [permission]: !permissions[permission]
    });
  };

  return (
    <div className="space-y-4">
      {Object.entries(permissionGroups).map(([group, perms]) => (
        <div key={group} className="border rounded-lg p-4">
          <h4 className="font-semibold text-gray-700 mb-3">{group}</h4>
          <div className="space-y-2">
            {perms.map(perm => (
              <div key={perm} className="flex items-center justify-between">
                <label className="text-sm text-gray-600">{permissionLabels[perm]}</label>
                <button
                  type="button"
                  onClick={() => handleToggle(perm)}
                  className={`flex items-center space-x-1 px-3 py-1 rounded-full text-sm ${
                    permissions[perm]
                      ? 'bg-green-100 text-green-700 hover:bg-green-200'
                      : 'bg-red-100 text-red-700 hover:bg-red-200'
                  }`}
                >
                  {permissions[perm] ? (
                    <>
                      <FiCheckCircle size={14} />
                      <span>Permitido</span>
                    </>
                  ) : (
                    <>
                      <FiXCircle size={14} />
                      <span>Denegado</span>
                    </>
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PermissionEditor;